import { IGLAccountServiceMock } from './accounting.mock.types';

export const mockGLAccountService = (): IGLAccountServiceMock => ({
  fetchGLAccounts: jest.fn(),
  fetchGLAccount: jest.fn(),
  createGLAccount: jest.fn(),
  updateGLAccount: jest.fn(),
  deleteGLAccount: jest.fn()
});
